<template>
    <validate-form ref="form" tag="div">
        <portal to="buttons">

            <b-button v-if="item.type != 20" variant="outline-info" @click="queueLabel" class="mx-5 my-5">
                Print etikette
            </b-button>

            <b-button variant="outline-secondary" type="reset" @click="getItem" class="mx-5 my-5">
                Annuller
            </b-button>

            <b-button @click="saveItem" variant="primary" class="mx-5 my-5" :disabled="loading">
                <b-spinner v-if="loading" small></b-spinner>
                {{ editing ? "Gem ændringer" : "Opret produkt" }}
            </b-button>
        </portal>
        <b-form>

            <b-tabs style="margin-top: -10px;">
                <b-tab>
                    <template #title>
                        <feather-icon icon="TagIcon" />
                        <span>Produkt</span>
                    </template>

                    <b-row>
                        <b-col cols="12" md="6">
                            <b-card>
                                <div class="row">
                                    <b-col cols="12" md="7">
                                        <FormGroup v-model="item.name" label="Navn" rules="required"></FormGroup>
                                    </b-col>
                                    <b-col cols="12" md="5">
                                        <FormGroup v-model="item.sku" label="SKU" rules=""></FormGroup>
                                    </b-col>

                                    <b-col cols="12" md="6" v-if="item.type != 30">
                                        <FormGroup label="Type" rules="">
                                            <template #input>
                                                <b-form-select v-model="item.type" :options="types" />
                                            </template>
                                        </FormGroup>
                                    </b-col>

                                    <!--<b-col cols="12" md="6" v-if="item.type != 30">
                                        <FormGroup label="Kategori" rules="">
                                            <template #input="{state}">
                                                <v-select v-model="item.category" :options="categories" @search="fetchCategories" placeholder="Vælg kategori" :filterable="false">
                                                    <template slot="option" slot-scope="option">
                                                        {{ option.name }}
                                                    </template>
                                                    <template slot="selected-option" slot-scope="option">
                                                        {{ option.name }}
                                                    </template>
                                                </v-select>
                                            </template>
                                        </FormGroup>
                                    </b-col>


                                    <b-col cols="12" md="6" v-if="item.type != 30">
                                        <FormGroup label="Alternative kategorier" rules="">
                                            <template #input="{state}">
                                                <v-select v-model="item.categories" :options="categories" multiple @search="fetchCategories" placeholder="Vælg kategori" :filterable="false">
                                                    <template slot="option" slot-scope="option">
                                                        {{ option.name }}
                                                    </template>
                                                    <template slot="selected-option" slot-scope="option">
                                                        {{ option.name }}
                                                    </template>
                                                </v-select>
                                            </template>
                                        </FormGroup>
                                    </b-col>-->

                                    <b-col cols="12" md="6" v-if="item.type != 30">
                                        <FormGroup label="Stregkode" rules="">
                                            <template #input>
                                                <b-input-group>
                                                    <b-form-input v-model="item.gtin"></b-form-input>
                                                    <b-input-group-append>
                                                        <b-button variant="outline-info" size="sm" class="py-5 px-7" @click="createGtin">
                                                            <feather-icon icon="PlusCircleIcon" size="16" class="" />
                                                        </b-button>
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </template>
                                        </FormGroup>
                                    </b-col>

                                    
                                    <b-col cols="12" md="6">
                                        <FormGroup v-model="item.gtiN_SW" label="GTIN" rules=""></FormGroup>
                                    </b-col>

                                    <b-col cols="12" md="6" v-if="item.type != 30">
                                        <FormGroup v-model="item.sort" label="Sortering" rules="" type="number"></FormGroup>
                                    </b-col>
                                    <!--<b-col cols="12" md="6">
                                        <FormGroup v-model="item.url" label="URL" rules=""></FormGroup>
                                    </b-col>-->

                                    <b-col cols="12" v-if="item.type == 30">
                                        <b-form-checkbox v-model="item.inactive" class="mb-8">
                                            Ikke aktiv
                                        </b-form-checkbox>
                                    </b-col>
                                    <b-col cols="12" md="6" v-else>
                                        <b-form-checkbox v-model="item.inactive" class="mb-8">
                                            Ikke aktiv
                                        </b-form-checkbox>

                                        <b-form-checkbox v-model="item.hidden">
                                            Individuelt skjult
                                        </b-form-checkbox>
                                    </b-col>

                                    <!--<b-col cols="12" md="6" v-if="item.type != 30">
                                        <FormGroup label="Begrænset til butikker" rules="">
                                            <template #input="{state}">
                                                <v-select v-model="item.stores" multiple :options="$store.state.stores" placeholder="Vælg butikker" :reduce="x => x.id">
                                                    <template slot="option" slot-scope="option">
                                                        {{ option.name }}
                                                    </template>
                                                    <template slot="selected-option" slot-scope="option">
                                                        {{ option.name }}
                                                    </template>
                                                </v-select>
                                            </template>
                                        </FormGroup>
                                    </b-col>-->
                                </div>


                                
                            </b-card>

                            <b-card title="Priser">
                                <div class="row">
                                    <b-col cols="12" md="4">
                                        <FormGroup v-model="item.price" label="Pris" rules="required"></FormGroup>
                                    </b-col>
                                    <b-col cols="12" md="4">
                                        <FormGroup v-model="item.discount" label="Rabat" rules=""></FormGroup>
                                    </b-col>
                                    <b-col cols="12" md="4">
                                        <FormGroup v-model="item.costPrice" label="Kostpris" rules=""></FormGroup>
                                    </b-col>
                                </div>
                            </b-card>


                            <b-card title="Lagerstyring">
                                <div class="row">
                                    <b-col cols="12" md="6">
                                        <FormGroup v-model="item.stock" label="Lager" rules=""></FormGroup>

                                        <FormGroup v-model="item.minQuantity" label="Minimum antal" type="number" rules=""></FormGroup>

                                        <FormGroup no-label rules="" v-if="item.type != 30">
                                            <template #input="{state}">
                                                <b-form-checkbox v-model="item.trackStock" :state="state">
                                                    Automatisk lagerstyring
                                                </b-form-checkbox>
                                            </template>
                                        </FormGroup>
                                    </b-col>
                                    <b-col cols="12" md="6">
                                        <FormGroup v-model="item.weight" label="Vægt" rules=""></FormGroup>

                                        <FormGroup v-model="item.unit" label="Enhed" rules="" v-if="item.type != 30"></FormGroup>


                                    </b-col>
                                </div>
                            </b-card>


                        </b-col>
                        <b-col cols="12" md="6">
                            <b-card title="Indhold">
                                <!--<FormGroup v-model="item.pageTitle" label="Sidetitel" rules="required"></FormGroup>-->

                                <b-tabs>
                                    <b-tab title="Kort beskrivelse">
                                        <editor v-model="item.description1" :init="editorConfig" api-key="1omqmjmnhfis5mkj5e0mj2rjzh22wjqhi39nq3ala2vq3yvo"></editor>
                                    </b-tab>
                                    <b-tab title="Beskrivelse">
                                        <editor v-model="item.description2" :init="editorConfig" api-key="1omqmjmnhfis5mkj5e0mj2rjzh22wjqhi39nq3ala2vq3yvo"></editor>
                                    </b-tab>
                                </b-tabs>
                            </b-card>

                            <b-card>
                                <b-overlay :show="!editing" rounded="sm">
                                    <Images v-model="item.images" :url="'/api/categories/upload-images/' + id" :delete-url="'/api/categories/delete-image/' + id"
                                            @uploaded="getItem" @deleted="getItem"></Images>

                                    <template #overlay>
                                        <feather-icon icon="InfoIcon" size="18" class="mb-2" />
                                        <span class="px-10">Opret produkt for at uploade billeder</span>
                                    </template>
                                </b-overlay>
                            </b-card>
                        </b-col>
                    </b-row>

                </b-tab>

                <!--<b-tab>
                    <template #title>
                        <feather-icon icon="PlusSquareIcon" />
                        <span>Tilvalg</span>
                    </template>

                    <b-row>
                        <b-col cols="12">
                            <Options v-model="item.options"></Options>
                        </b-col>
                    </b-row>
                </b-tab>-->

                <b-tab v-if="item.type == 20">
                    <template #title>
                        <feather-icon icon="BoxIcon" />
                        <span>Varianter</span>
                    </template>

                    <b-row>
                        <b-col cols="12">
                            <Variants v-model="item.variants" @update="saveItem"></Variants>
                        </b-col>
                    </b-row>
                </b-tab>

                <!--<b-tab v-if="item.type == 10">
                    <template #title>
                        <feather-icon icon="ArchiveIcon" />
                        <span>Samlinger</span>
                    </template>

                    <b-row>
                        <b-col cols="12">
                            <Collection v-model="item.collection"></Collection>
                        </b-col>
                    </b-row>
                </b-tab>-->


                <!--<b-tab>
                    <template #title>
                        <feather-icon icon="ListIcon" />
                        <span>Specifikationer</span>
                    </template>

                    <b-row>
                        <b-col cols="12">
                            <Specifications v-model="item.specifications"></Specifications>
                        </b-col>
                    </b-row>
                </b-tab>-->

            </b-tabs>


            <LabelModal ref="labelModal"></LabelModal>

        </b-form>

    </validate-form>

</template>

<script>
    import Toast from '@/components/_toast.vue'
    import Options from './_Options.vue'
    import Specifications from './_Specifications.vue'
    import Collection from './_Collection.vue'
    import Variants from './_Variants.vue'
    import LabelModal from './_labelModal.vue'

    export default {
        components: { Variants, LabelModal },
        data: () => ({
            loading: false,
            item: {
                id: null,
                type: 0,
                category: null,
                categories: [],
                options: [],
                specifications: [],
                collection: []
            },
            categories: [],
            shippingTypes: [],
            types: [
                { value: 0, text: 'Standard' },
                //{ value: 10, text: 'Samling' },
                { value: 20, text: 'Produkt med varianter' },
                //{ value: 30, text: 'Produktvariant' },
            ],
            editorConfig: {
                height: 300,
                plugins: [
                    'lists link image paste code'
                ],
                toolbar: 'undo redo | formatselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link image | code',
                menubar: ""
            }
        }),
        computed: {
            id() {
                return this.$route.params.id
            },
            editing() {
                return this.id != "create"
            }
        },
        created() {
            if (this.editing) {
                this.getItem()
            } else {
                this.$store.dispatch("app/UPDATE_PAGETITLE", "Opret produkt")
            }
        },
        mounted() { },
        methods: {
            getItem() {
                if (this.editing) {
                    this.$http.get("/api/products/" + this.id).then(x => {
                        this.item = x.data

                        this.$store.dispatch("app/UPDATE_PAGETITLE", x.data.name)
                    })
                } else {
                    this.$router.push("/products")
                }
            },

            createGtin() {
                this.$http.post("/api/products/create-gtin").then(x => {
                    this.item.gtin = x.data
                })
            },
            queueLabel() {
                var print = {
                    name: this.item.name,
                    price: this.item.price,
                    gtin: this.item.gtin,
                    quantity: 1
                }

                this.$refs.labelModal.print = print
                this.$refs.labelModal.show()
            },

            saveItem(cb) {
                this.loading = true
                this.$refs.form.validate().then(success => {
                    if (success) {
                        this.$http.post("/api/products/save", this.item).then(x => {

                            this.$toast({
                                component: Toast,
                                props: {
                                    title: x.data.result,
                                    icon: 'CheckCircleIcon',
                                    variant: 'success',
                                },
                            })

                            if (x.data.data) {
                                this.$router.replace({ name: "product", params: { id: x.data.data } })
                            }

                            this.getItem()

                            
                            if (cb && (typeof cb) == "function") {
                                cb()
                            }

                            this.loading = false
                        })
                    }
                })
            }
        },
    }
</script>